export default "__VITE_ASSET__BvQ$DhYZ__"